import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const createLead = (data) => axios.post(`${API}/leads`, data).then((r) => r.data);
export const createBooking = (data) => axios.post(`${API}/bookings`, data).then((r) => r.data);
export const subscribe = (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data);

export const checklistInfo = () => axios.get(`${API}/checklist/info`).then((r) => r.data);
export const CHECKLIST_DOWNLOAD_URL = `${API}/checklist/download`;
export const uploadChecklist = (fileFormData) =>
  axios.post(`${API}/admin/checklist/upload`, fileFormData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);

export const adminGet = (path) => axios.get(`${API}/admin/${path}`).then((r) => r.data);

export const createCheckout = (data) => axios.post(`${API}/payments/checkout`, data).then((r) => r.data);
export const getPaymentStatus = (sid) => axios.get(`${API}/payments/status/${sid}`).then((r) => r.data);
export const sendChat = (session_id, message) => axios.post(`${API}/chat`, { session_id, message }).then((r) => r.data);
export const getAvailability = (date) => axios.get(`${API}/bookings/availability?date=${date}`).then((r) => r.data);

// Auth
export const authRegister = (data) => axios.post(`${API}/auth/register`, data).then((r) => r.data);
export const authLogin = (data) => axios.post(`${API}/auth/login`, data).then((r) => r.data);
export const authLogout = () => axios.post(`${API}/auth/logout`).then((r) => r.data);
export const authMe = () => axios.get(`${API}/auth/me`).then((r) => r.data);
export const authForgot = (email) => axios.post(`${API}/auth/forgot-password`, { email }).then((r) => r.data);
export const authReset = (token, password) => axios.post(`${API}/auth/reset-password`, { token, password }).then((r) => r.data);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
